<template>
  <div class="bg-gradient-lighter min-vh-100">
    <!-- Header -->
    <div class="header bg-gradient-orange py-7 py-lg-8 pt-lg-9">
      <div class="container">
        <div class="header-body text-center mb-7">
          <div class="row justify-content-center">
            <div class="col-xl-5 col-lg-6 col-md-8 px-5">
              <h1 class="text-white">Registered Successfully</h1>
              <p class="text-lead text-white">
                Earn affiliate commissions while learning Chinese with
                ChinesePod!
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="separator separator-bottom separator-skew zindex-100">
        <svg
          x="0"
          y="0"
          viewBox="0 0 2560 100"
          preserveAspectRatio="none"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
        >
          <polygon
            class="fill-default"
            points="2560 0 2560 100 0 100"
          ></polygon>
        </svg>
      </div>
    </div>
    <!-- Page content -->
    <div class="container mt--9 pb-5">
      <!-- Table -->
      <div class="row justify-content-center">
        <div class="col-lg-6 col-md-8">
          <div class="card bg-secondary border-0">
            <div class="card-body px-lg-5 py-lg-5">
              <p>
                If you qualify for our program, you will receive an affiliate
                link to share with anyone who wants to learn Chinese using our
                unique content.
              </p>
              <p>
                As soon as our link is up, you can start making money from
                anyone clicking your affiliate link and registering as a
                subscriber with 30 days of clicking your affiliate link, even if
                they don’t pay for the subscription<strong>*</strong>.
              </p>
              <p>
                You will also be paid if the subscriber upgrades their plan in
                the first 60 days of subscribing to a paid plan.
              </p>
            </div>
            <div class="card-footer">
              <p class="small">
                * Subscriber needs to register and confirm their account within
                a 14 day period.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  title() {
    return `${this.$route.name} | ChinesePod SchoolZone`
  }
}
</script>
